import React from 'react';
export function Footer() {
  return <footer className="bg-brand-950 px-5 pb-32 pt-10 text-center" data-id="element-185" data-mp="19ivlq3plplne">
      <p className="font-display text-xl font-bold text-white" data-id="element-186" data-mp="208ce79corfro">7D Apometry Protocol™</p>
      <p className="mt-1 text-sm text-brand-200" data-id="element-187" data-mp="2f5d211rraqkv">Created by Helena Duarte</p>
      <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-brand-300" data-id="element-188" data-mp="2a5qpkujr5ed4">
        The practices and concepts presented are within the scope of spirituality and personal practices. They do not
        constitute medical or psychological diagnosis or treatment and do not replace care from qualified professionals.
      </p>
      <p className="mt-6 text-xs text-brand-300" data-id="element-189" data-mp="1w70utlkenqrx">© 2026 · 7D Apometry Protocol™ · All Rights Reserved.</p>
    </footer>;
}